import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';

const hintStyle = css`
	margin: 0;
	padding: 0.75rem 0.875rem;
	border-radius: ${theme.radii.medium};
	background-color: ${theme.colors.accentSurface};
	color: ${theme.colors.accentDark};
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.medium};
	font-weight: ${theme.fontWeights.medium};
`;

type Props = {
	/** How many times the field is displayed in the document. */
	readonly count: number;
};

/** Tells that a modification shows up in several places; renders nothing for a single occurrence. */
const FieldOccurrencesHint: React.FC<Props> = ({ count }) => {
	if (count <= 1) {
		return null;
	}

	return <p css={hintStyle}>Apparaît {count} fois dans le document.</p>;
};

export default FieldOccurrencesHint;
